import React, { useMemo } from 'react';
import 'ol/ol.css';
import { NewReaction } from '@/types/models';
import { getReactionBoundingBox } from '@/components/FunctionalArea/Modal/EditReactionModal/utils/getReactionBoundingBox';
import { useReactionDiagramPreview } from '@/components/FunctionalArea/Modal/EditReactionModal/utils/useReactionDiagramPreview';

type ReactionDiagramPreviewProps = {
  reaction: NewReaction;
};

export const ReactionDiagramPreview: React.FC<ReactionDiagramPreviewProps> = ({ reaction }) => {
  const boundingBox = useMemo(() => getReactionBoundingBox(reaction), [reaction]);
  const { targetRef } = useReactionDiagramPreview(boundingBox);

  return <div ref={targetRef} className="h-full w-full" data-testid="reaction-diagram-preview" />;
};
